import { Bar } from 'vue-chartjs'
 
export default {
	extends: Bar,
	data: function(){
		return {
	
			data : {
		            
	                labels: ["0%", "25%", "50%", "75%", "100%"],
			        links: ['http://google.es','http://google.es','http://google.es','http://google.es','http://marca.com'],
			        colors: ["#00777b", "#00777b","#00777b","#00777b","#00777b"],
			        opacityColors: ["#00777b", "#00777b","#00777b","#00777b","#00777b"],
				      datasets: [
				        {
				          label: '',
				          backgroundColor: ["#00777b", "#00777b","#00777b","#00777b","#00777b"],
				          data: [30,20,54,25,12]
				        }
				      ]
              },
            options:{
	            /*onClick:function(evt){
	                var activePoints = this.getElementsAtEvent(evt);
		            var firstPoint = activePoints[0];
					var link = this.data.links[firstPoint._index];
					alert(link);
	            },*/
	            onClick: function(evt, activeElements) {
			      var elementIndex = activeElements[0]._index;
			      var bars = this.data.datasets[0].backgroundColor;
			      for (var i = 0; i < bars.length; i+=1) {
				      if( i == elementIndex){
					  	this.data.datasets[0].backgroundColor[i] = this.data.colors[i];
					  }else{
					  	this.data.datasets[0].backgroundColor[i] = this.data.opacityColors[i];
					  }
					}
			      
			      this.update();
			    },
	            responsive: true,
	            scales: {
			        yAxes: [{
			            ticks: {
			                beginAtZero: true,
			                min: 0
			            }
			        }]
			    },
	        }
        }
    },
	mounted () {
		var colors = this.data.colors;
		
		var opacityColors = this.data.opacityColors;
		
		colors.forEach(function(key, value){
			var c;
	        c= key.substring(1).split('');
	        if(c.length== 3){
	            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
	        }
	        c= '0x'+c.join('');
	         opacityColors[value] = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',.2)';
		});
		
		
		this.renderChart(this.data, this.options);
	}
}


// WEBPACK FOOTER //
// ./src/components/charts/TestChart.js